import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiCopy, FiCheck } from 'react-icons/fi';

const CopyBlock = ({ title, text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="bg-slate-800 rounded-lg border border-slate-700 overflow-hidden my-4">
      <div className="flex justify-between items-center px-4 py-2 bg-slate-900 border-b border-slate-700">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">{title}</span>
        <button 
          onClick={handleCopy}
          className="flex items-center space-x-1 text-xs text-slate-400 hover:text-white transition-colors"
        >
          <SafeIcon icon={copied ? FiCheck : FiCopy} className={copied ? "text-emerald-400" : ""} />
          <span className={copied ? "text-emerald-400" : ""}>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </div>
      <div className="p-4 text-sm text-slate-300 whitespace-pre-wrap font-mono leading-relaxed">
        {text}
      </div>
    </div>
  );
};

export default CopyBlock;